import * as React from 'react';
import { useSelector } from 'react-redux';
import { getPathname } from '~/selectors/router.selectors';
import { getUser } from '~/selectors/user.selectors';
import { getCookie } from '~/utils/cookies';

const SiftMonitor = () => {
  const user = useSelector(getUser);
  const pathName = useSelector(getPathname);
  const siftUserPrefix = 'login_user:';

  const isImpersonatingCookie = getCookie('is_impersonate') || '';
  const isImpersonating = isImpersonatingCookie.toLowerCase() === 'true';
  const sessionId = getCookie('sessionid') || '';

  const siftConfig = (window._sift = window._sift || []);

  // We do not want to send any events when a user is being impersonated
  if (!isImpersonating) {
    siftConfig.push(['_setAccount', CONFIG.siftAccount]);
  }

  // Want to only send an event to Sift when the data for user, sessionId, or pathName changes
  React.useEffect(() => {
    if (!isImpersonating && user) {
      siftConfig.push(['_setUserId', siftUserPrefix + user.loginUserId.toString()]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  React.useEffect(() => {
    if (!isImpersonating && sessionId) {
      siftConfig.push(['_setSessionId', sessionId]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  React.useEffect(() => {
    if (!isImpersonating) {
      siftConfig.push(['_trackPageview']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName]);

  return null;
};

export default SiftMonitor;
